import { render, staticRenderFns } from "./ProjectSocialPlatformInstagram.vue?vue&type=template&id=6f3d4268"
import script from "./ProjectSocialPlatformInstagram.vue?vue&type=script&lang=ts"
export * from "./ProjectSocialPlatformInstagram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports